import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import ProductrawtorawdemandDashboard from '../ProductrawtorawdemandDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function ProductrawtorawdemandPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < ProductrawtorawdemandDashboard />
    )

}